import { render, staticRenderFns } from "./ScoutCreateMessage.vue?vue&type=template&id=e10867d6"
import script from "./ScoutCreateMessage.vue?vue&type=script&lang=js"
export * from "./ScoutCreateMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports